import * as ss from 'superstruct';

/**
 * The configuration for sending conversions to Google Ads via the
 * Google Data Manager API. The stream's ad account is the operating account:
 * the customer that owns the conversion action.
 *
 * https://developers.google.com/data-manager/api
 */
export const GoogleAdsDataManagerOutputStreamDestination = ss.type({
  name: ss.literal('google-ads-data-manager'),
  /**
   * Numeric conversion action ID. Should NOT include the
   * `customers/X/conversionActions/` resource-name prefix.
   */
  conversionActionId: ss.string(),
  /**
   * If we should send any identifying info in the conversion
   * (email, phone).
   */
  enhanced: ss.boolean(),
});

export type GoogleAdsDataManagerOutputStreamDestination = ss.Infer<
  typeof GoogleAdsDataManagerOutputStreamDestination
>;
